module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_0@2x.513247a6.png";